module.exports = __webpack_public_path__ + "img/profile.b9a679e4.svg";